var map = {
	"./17-cn.webp": 1166,
	"./17.webp": 1167,
	"./27-cn.webp": 1168,
	"./27.webp": 1169,
	"./7-cn.webp": 1170,
	"./7.webp": 1171,
	"./angpao-bg-mobile.jpg": 1172,
	"./angpao-bg.jpg": 1173,
	"./angpao-cn.webp": 1174,
	"./angpao.webp": 1175,
	"./button.png": 1176,
	"./close-eye.png": 1177,
	"./coin-1.png": 1178,
	"./coin.png": 1179,
	"./ketupak-open.png": 1180,
	"./ketupak.png": 1181,
	"./ketupak_ribbon.png": 1182,
	"./rain-1.png": 1183,
	"./rain-2.png": 1184,
	"./rain-3.png": 1185,
	"./raya-bg-mobile.png": 1186,
	"./raya-bg.png": 1187,
	"./shine.png": 1188,
	"./star-1.png": 1189,
	"./star-2.png": 1190
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 458;